import useProjectDomains from "../../../../api/utilities/useProjectDomains.js";
import Spinner from "../../../../components/Spinner.jsx";
import {useTranslation} from "react-i18next";
import Button from "../../../../components/Button.jsx";
import Creatable from "react-select/creatable";
import {useEffect, useMemo, useState} from "react";
import LoadingComponent from "../../../../components/LoadingComponent.jsx";
import {ProjectApi} from "../../../../api/authority/generated/index";
import useAuthorityConfiguration from "../../../../api/utilities/useAuthorityConfiguration.js";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrashCan} from "@fortawesome/free-regular-svg-icons";

export default function HostNameAndXmlLinkList({project, projectIntegration, value, onChange}) {
    let {t} = useTranslation();
    let authorityConfiguration = useAuthorityConfiguration();

    let projectDomains = useProjectDomains(project);
    let [projectDomainNamesWithXmlLinks, setProjectDomainNamesWithXmlLinks] = useState(null);

    useEffect(() => {
        if (projectIntegration === null) {
            setProjectDomainNamesWithXmlLinks([]);
            return;
        }

        new ProjectApi(authorityConfiguration)
            .hostNameAndXMLLink({
                integrationId: projectIntegration.id
            })
            .then(setProjectDomainNamesWithXmlLinks)
            .catch(() => setProjectDomainNamesWithXmlLinks([]));
    }, [project.id, projectIntegration?.id]);

    useEffect(() => {
        onChange(projectDomainNamesWithXmlLinks);
    }, [projectDomainNamesWithXmlLinks]);

    let hostNameOptions = useMemo(() => {
        if (projectDomains === null) {
            return [];
        }
        return projectDomains.map((projectDomain) => ({
            value: projectDomain.projectDomain.hostName,
            label: projectDomain.projectDomain.hostName
        }));
    }, [projectDomains]);

    return <LoadingComponent
        className={'border-1 p-3 border-slate-500 rounded'}
        loading={projectDomainNamesWithXmlLinks === null}
    >
        {projectDomains === null && <Spinner/>}
        {projectDomains && <div>
            {(value ?? []).map((row, index) => {
                return <div className={'flex gap-2 pt-2'} key={'xml-link-row-' + index}>
                    <Creatable
                        value={{label: row.hostName, value: row.hostName}}
                        className={'w-4/12'}
                        onChange={(e) => {
                            value[index] = {...row, hostName: e.value};
                            onChange(value);
                        }}
                        options={hostNameOptions}
                    />
                    <input
                        value={row.xmlLink}
                        className={'w-7/12 form-input'}
                        type={'text'}
                        onChange={(e) => {
                            value[index] = {...row, xmlLink: e.target.value};
                            onChange(value);
                        }}
                    />
                    <Button
                        className={'button button-danger-outline w-1/12'}
                        onClick={() => {
                            //delete value[index];
                            onChange(value.filter((x, checkedIdx) => index !== checkedIdx));
                        }}
                    >
                        <FontAwesomeIcon icon={faTrashCan}/>
                    </Button>
                </div>;
            })}
        </div>}
        <div className={'pt-2'}>
            <Button
                className={'button button-success-outline'}
                onClick={() => {
                    onChange([...value, {hostName: '', xmlLink: ''}]);
                }}
            >
                {t('add-hostname-and-xml-link')}
            </Button>
        </div>
    </LoadingComponent>;
}